import { MedicationApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const medicationApi = new MedicationApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
